<template>
  <!-- <v-flex xs4 style="border: 2 0 0 0 #cecece;"> -->
    <!-- <div style="box-shadow: 1px 1px 1px #cecece;"> -->
    <div :class="origin_field_name === 'connection_id' ? '' : 'right-side'">
      <!-- Dialog para mostrar a mensagem nos campos do cliente -->
      <v-dialog v-model="dialogConfirmConnection" @keydown.enter="openCustomFieldEditable(true)" persistent max-width="300" scrollable>
        <v-card>
          <v-card-text justify-center>
            <p class="text-md-center" style="margin:0">Todas as alterações feitas nos outros campos do cliente, serão feitas para todos os clientes!</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn id="confirm_connection" class="mx-0" flat color="primary" @click.native="openCustomFieldEditable(true)">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Divider para quando está no mobile e passa pra linha de baixo -->
      <v-divider></v-divider>
      <!-- // v-if="$auth.check()" caso o usuário naõ esteja logado não precisa carregar o p-custom-field-editable -->
      <p-custom-field-editable v-if="$auth.check()" ref="customFieldEditable" :origin_field_name="origin_field_name" :task_id="task_id" :tasktemplate_id="tasktemplate_id" @changeCustomFields="changeCustomFields" :originView="originView"></p-custom-field-editable>
      <v-card elevation="0" style="background-color:#fafafa;">
        <v-card-title class="py-2">
          <v-layout row justify-space-between wrap>
            <h3>{{this.origin_field_name === 'connection_id' ? 'Outros Campos' : 'Campos Personalizados'}}</h3>
            <v-tooltip bottom>
              <v-chip slot="activator" style="height:20px;" outline color="primary" @click="$store.commit('dialogBeta/change_values', { text: 'Agora suas tarefas estão bem mais personalizadas!', link:`https://app.api.illis.com.br/images/customFields.mp4`, showDialog: true })" class="beta">
                beta<v-icon>play_arrow</v-icon></v-chip>
              <span>Clique no botão beta para mais informações</span>
            </v-tooltip>
          </v-layout>
        </v-card-title>
        <v-divider style="padding-bottom:5px;"></v-divider>
        <v-card-text class="pa-0" :style="origin_field_name === 'connection_id' ? '' : 'overflow-y: auto; overflow-x: hidden; min-height: 80%;'">
          <v-layout wrap>
            <!-- <v-card-text class="pa-0" style="overflow-y: auto; overflow-x: hidden; min-height: 80%;"> -->
            <v-flex v-if="loadingCustomFields">
              <v-progress-linear indeterminate :height="3" class="mb-0"></v-progress-linear>
            </v-flex>
            <v-flex v-else :class="origin_field_name === 'connection_id' ? 'xs12 sm4' : 'xs12 flex-custom-field'" v-for="(field, index) in customFields" :key="index">
              <!--//-------------------------campo INTEGER---------------------->
              <span v-if="field['type'] === 'number'">
                <v-hover :disabled="task_shared || $vuetify.breakpoint.smAndDown">
                  <v-form slot-scope="{ hover }" :ref="'cf_ '+ field['id'] + '_form'">
                    <!-- // usado o value para receber o valor do campo pois o value pode tanto ser do id_text da tabela custom_field quando for da tarefa modelo ou o id_text da tarefa task_custom_field quando for da tarefa -->
                    <v-text-field type="number" v-if="fieldEditing['cf_' + field['id']] || originView === 2 || origin_field_name === 'connection_id'" :id="'cf_' + field['id']" :label="field['title'] ? field['title'] : 'campo'" v-model="field['value']" @click="clickFieldEditing(field)" @blur="fieldEdit({id: field['id'], value: field['value']}, 'cf_' + field['id'])" @keyup.enter.exact="fieldEdit({id: field['id'], value: field['value']}, 'cf_' + field['id'])"></v-text-field>
                    <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                      <v-layout>
                        <v-flex xs11>
                          <div @click="clickFieldEdit(field)">
                            <div class="p-label">{{field['title']}}</div>
                            <div v-if="field['value']" class="p-content-field break-word" style="white-space: pre-line;"> {{field['value']}}</div>
                            <div v-else class="p-content-field-empty break-word">{{task_shared ? 'Campo vazio' : 'Digite um(a) ' + field['title']}}</div>
                          </div>
                        </v-flex>
                        <v-flex xs1>
                          <v-tooltip v-if="field['value'] != null && (hover || $vuetify.breakpoint.smAndDown) && !task_shared" bottom>
                            <v-btn class="btn-close-edit" slot="activator" icon @click="fieldEdit({id: field['id'], value: null}, 'cf_' + field['id'])"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-form>
                </v-hover>
              </span>
              <!--//-------------------------campo VALUE---------------------->
              <span v-else-if="field['type'] === 'value'">
                <v-hover :disabled="task_shared || $vuetify.breakpoint.smAndDown">
                  <v-form slot-scope="{ hover }" :ref="'cf_ '+ field['id'] + '_form'">
                    <!-- // usado o value para receber o valor do campo pois o value pode tanto ser do id_text da tabela custom_field quando for da tarefa modelo ou o id_text da tarefa task_custom_field quando for da tarefa -->
                    <p-money v-model="field['value']" :id="'cf_' + field['id']" v-if="fieldEditing['cf_' + field['id']] || originView === 2 || origin_field_name === 'connection_id'" @click="clickFieldEditing(field, true)" @blur="fieldEdit({id: field['id'], value: field['value']}, 'cf_' + field['id'])" :label="field['title'] ? field['title'] : 'campo'" @keyupEnter="fieldEdit({id: field['id'], value: field['value']}, 'cf_' + field['id'])"/>
                    <!-- <v-text-field v-money="moneyOptions" :value="field['value']" @input="(val) => field['value'] = inputMoney(val)" :id="'cf_' + field['id']" v-if="fieldEditing['cf_' + field['id']] || originView === 2 || origin_field_name === 'connection_id'" @click="clickFieldEditing(field)" @blur="fieldEdit({id: field['id'], value: field['value']}, 'cf_' + field['id'])" :label="field['title'] ? field['title'] : 'campo'" @keyup.enter.exact="fieldEdit({id: field['id'], value: field['value']}, 'cf_' + field['id'])"/> -->
                    <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                      <v-layout>
                        <v-flex xs11>
                          <div @click="clickFieldEdit(field, true, true)">
                            <div class="p-label">{{field['title']}}</div>
                            <div v-if="field['value'] && field['value'] != 0" class="p-content-field break-word" style="white-space: pre-line;">R$ {{parseFloat(field['value']).toLocaleString('pt-BR')}}</div>
                            <div v-else class="p-content-field-empty break-word">{{task_shared ? 'Campo vazio' : 'Digite um(a) ' + field['title']}}</div>
                          </div>
                        </v-flex>
                        <v-flex xs1>
                          <v-tooltip v-if="field['value'] != null && (hover || $vuetify.breakpoint.smAndDown) && !task_shared" bottom>
                            <v-btn class="btn-close-edit" slot="activator" icon @click="fieldEdit({id: field['id'], value: null}, 'cf_' + field['id'])"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-form>
                </v-hover>
              </span>
              <!--//-------------------------campo STRING---------------------->
              <span v-else-if="['string', 'email', 'phone'].includes(field['type'])">
                <v-hover :disabled="task_shared || $vuetify.breakpoint.smAndDown">
                  <v-form slot-scope="{ hover }" :ref="'cf_ '+ field['id'] + '_form'">
                    <!-- // usado o value para receber o valor do campo pois o value pode tanto ser do id_text da tabela custom_field quando for da tarefa modelo ou o id_text da tarefa task_custom_field quando for da tarefa -->
                    <v-text-field v-if="fieldEditing['cf_' + field['id']] || originView === 2 || origin_field_name === 'connection_id'" :id="'cf_' + field['id']" :label="field['title'] ? field['title'] : 'campo'" v-model="field['value']" @click="clickFieldEditing(field)" @blur="fieldEdit({id: field['id'], value: field['value']}, 'cf_' + field['id'])" @keyup.enter.exact="fieldEdit({id: field['id'], value: field['value']}, 'cf_' + field['id'])" :mask="getMaskField(field['type'])" validate-on-blur :rules="getRuleField(field['type'], field['title'] ? field['title'] : 'campo')"></v-text-field>
                    <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                      <v-layout>
                        <v-flex xs11>
                          <div @click="clickFieldEdit(field)">
                            <div class="p-label">{{field['title']}}</div>
                            <div v-if="field['value']" class="p-content-field break-word" style="white-space: pre-line;"> {{applyMaskField(field['value'], getMaskField(field['type']))}}</div>
                            <div v-else class="p-content-field-empty break-word">{{task_shared ? 'Campo vazio' : 'Digite um(a) ' + field['title']}}</div>
                          </div>
                        </v-flex>
                        <v-flex xs1>
                          <v-tooltip v-if="field['value'] != null && (hover || $vuetify.breakpoint.smAndDown) && !task_shared" bottom>
                            <v-btn class="btn-close-edit" slot="activator" icon @click="fieldEdit({id: field['id'], value: null}, 'cf_' + field['id'])"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-form>
                </v-hover>
              </span>
              <!--//-------------------------campo SELECT---------------------->
              <span v-else-if="field['type'] === 'select'">
                <v-hover :disabled="task_shared || $vuetify.breakpoint.smAndDown">
                  <v-form slot-scope="{ hover }" :ref="'cf_ '+ field['id'] + '_form'">
                    <!-- // usado o value para receber o valor do campo pois o value pode tanto ser do id_text da tabela custom_field quando for da tarefa modelo ou o id_text da tarefa task_custom_field quando for da tarefa -->
                    <!-- // itemsProps quando for inclusão de tarefa modelo, pega as opções que foram inseridas para mostrar apenas elas -->
                    <p-select :id="'cf_' + field['id']" v-if="fieldEditing['cf_' + field['id']] || originView === 2 || origin_field_name === 'connection_id'" entity="custom_field" @change="(id, item) => {fieldEdit({id: field['id'], value: field['value']}, 'cf_' + field['id'])}" :where="'custom_field_id=' + field['id']" :disabled="(field['company_id'] !== $auth.user().company_id)" :label="field['title'] ? field['title'] : 'campo'" :value="parseInt(field['value'])" @input="(val) => {field['value'] = val}" :selectedItem="field['value_item']" @click="clickFieldEditing(field)" @blur="fieldEditing['cf_' + field['id']] = false" :companyId="field['company_id']" @keyup.enter.exact="fieldEdit({id: field['id'], value: field['value']}, 'cf_' + field['id'])" :itemsProps="(originView == 2 && origin_field_name === 'tasktemplate_id') ? $store.getters[`${origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/options`](field['id'])  : null" @close="fieldEditing['cf_' + field['id']] = false"></p-select>
                    <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                      <v-layout>
                        <v-flex xs11>
                          <div @click="clickFieldEdit(field)">
                            <div class="p-label">{{field['title']}}</div>
                            <div v-if="field['value_item'] && field['value_item']['id_text']" class="p-content-field break-word" style="white-space: pre-line;"> {{field['value_item']['id_text']}}</div>
                            <div v-else class="p-content-field-empty break-word">{{task_shared ? 'Campo vazio' : 'Escolha uma opção'}}</div>
                          </div>
                        </v-flex>
                        <v-flex xs1>
                          <v-tooltip v-if="field['value'] != null && (hover || $vuetify.breakpoint.smAndDown) && !task_shared" bottom>
                            <v-btn class="btn-close-edit" slot="activator" icon @click="fieldEdit({id: field['id'], value: null}, 'cf_' + field['id'])"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-form>
                </v-hover>
              </span>
              <!--//-------------------------campo MULTISELECT---------------------->
              <span v-else-if="field['type'] === 'multiselect'">
                <v-hover :disabled="task_shared || $vuetify.breakpoint.smAndDown">
                  <v-form slot-scope="{ hover }" :ref="'cf_ '+ field['id'] + '_form'">
                    <!-- // usado o value para receber o valor do campo pois o value pode tanto ser do id_text da tabela custom_field quando for da tarefa modelo ou o id_text da tarefa task_custom_field quando for da tarefa -->
                    <!-- // itemsProps quando for inclusão de tarefa modelo, pega as opções que foram inseridas para mostrar apenas elas -->
                    <p-select multiple :value="field['value'] ? field['value'].split(',').map(Number) : null"
                    @input="(val) => {field['value'] = val.toString()}" :selectedItem="field['value_item']"
                    :id="'cf_' + field['id']" v-if="fieldEditing['cf_' + field['id']] || originView === 2 || origin_field_name === 'connection_id'" entity="custom_field" @blur="(id, item) => {fieldEdit({id: field['id'], value: field['value'].toString()}, 'cf_' + field['id'])}" :where="'custom_field_id=' + field['id']" :disabled="(field['company_id'] !== $auth.user().company_id)" :label="field['title'] ? field['title'] : 'campo'"  @click="clickFieldEditing(field)" :companyId="field['company_id']" @keyup.enter.exact="fieldEdit({id: field['id'], value: field['value']}, 'cf_' + fild['id'])" :itemsProps="(originView == 2 && origin_field_name === 'tasktemplate_id') ? $store.getters[`${origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/options`](field['id'])  : null" @close="fieldEditing['cf_' + field['id']] = false"></p-select>
                    <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                      <v-layout>
                        <v-flex xs11>
                          <div @click="clickFieldEdit(field)">
                            <div class="p-label">{{field['title']}}</div>
                            <div v-if="field['value_item'] && field['value_item'].length > 0" class="p-content-field break-word" style="white-space: pre-line;"> {{field['value_item'].map((val) => { return val['id_text'] }).toString()}}</div>
                            <div v-else class="p-content-field-empty break-word">{{task_shared ? 'Campo vazio' : 'Escolha uma opção'}}</div>
                          </div>
                        </v-flex>
                        <v-flex xs1>
                          <v-tooltip v-if="field['value'] != null && (hover || $vuetify.breakpoint.smAndDown) && !task_shared" bottom>
                            <v-btn class="btn-close-edit" slot="activator" icon @click="fieldEdit({id: field['id'], value: null}, 'cf_' + field['id'])"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-form>
                </v-hover>
              </span>
              <!--//-------------------------campo DATE---------------------->
              <span v-else-if="field['type'] === 'date'">
                <v-hover :disabled="task_shared || $vuetify.breakpoint.smAndDown">
                  <v-form slot-scope="{ hover }" :ref="'cf_ '+ field['id'] + '_form'">
                    <!-- // usado o value para receber o valor do campo pois o value pode tanto ser do id_text da tabela custom_field quando for da tarefa modelo ou o id_text da tarefa task_custom_field quando for da tarefa -->
                    <p-date v-if="fieldEditing['cf_' + field['id']] || originView === 2 || origin_field_name === 'connection_id'" :component_id="'cf_' + field['id']" :label="field['title'] ? field['title'] : 'campo'" v-model="field['value']" @click="clickFieldEditing(field)" @blur="fieldEdit({id: field['id'], value: field['value']}, 'cf_' + field['id'])" @keyupEnter="fieldEdit({id: field['id'], value: field['value']}, 'cf_' + field['id'])"></p-date>
                    <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                      <v-layout>
                        <v-flex xs11>
                          <div @click="clickFieldEdit(field)">
                            <div class="p-label">{{field['title']}}</div>
                            <div v-if="field['value']" class="p-content-field break-word" style="white-space: pre-line;"> {{field['value'] ? moment(field['value']).format('DD/MM/YYYY') : ''}}</div>
                            <div v-else class="p-content-field-empty break-word">{{task_shared ? 'Campo vazio' : 'Digite um(a) ' + field['title']}}</div>
                          </div>
                        </v-flex>
                        <v-flex xs1>
                          <v-tooltip v-if="field['value'] != null && (hover || $vuetify.breakpoint.smAndDown) && !task_shared" bottom>
                            <v-btn class="btn-close-edit" slot="activator" icon @click="fieldEdit({id: field['id'], value: null}, 'cf_' + field['id'])"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-form>
                </v-hover>
              </span>
              <!--//-------------------------campo FILES---------------------->
              <span v-else-if="field['type'] === 'files'">
                <v-form :ref="'cf_ '+ field['id'] + '_form'">
                  <div v-if="origin_field_name === 'tasktemplate_id'" class="show-edit">
                    <v-layout>
                      <v-flex xs12>
                        <div>
                          <div class="p-label">{{field['title']}}</div>
                          <div class="p-content-field-empty break-word">Campo de arquivo</div>
                        </div>
                      </v-flex>
                    </v-layout>
                  </div>
                  <div v-else style="padding-left:7px">
                    <p-file :blackLabel="originView == 4" :id="'cf_' + field['id']" :label="field['title'] ? field['title'] : 'campo'" :custom_field_id="field['id']" @addFiles="(val)=>addFiles(val, field)" :disabled="!checkPermission(originTable, (originView === 2 ? 'create' : 'edit')) || task_shared || !crud_access">
                    </p-file>
                  </div>
                </v-form>
              </span>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions v-if="origin_field_name === 'tasktemplate_id' || origin_field_name === 'connection_id'">
          <a color="primary" style="padding-left: 13px" small @click="openCustomFieldEditable(origin_field_name !== 'connection_id')">Adicionar/Editar Campos</a>
        </v-card-actions>
      </v-card>
    </div>
  <!-- </v-flex> -->
</template>

<style scoped>
  .right-side {
    border-left: 2px solid #cecece;
    height: 100%;
  }
  .btn-close-edit {
    position: relative;
    right: 25px;
  }
  .btn-close-edit-mobile {
    position: relative; 
    right: 35px;
  }
  .show-edit-border {
    cursor: pointer;
    min-height: 50px;
    border-radius: 5px;
    border: 1px solid;
    padding-left: 5px;
    padding-right: 8px;
  }
  .show-edit {
    min-height: 50px;
    border: 1px solid;
    border-color: rgba(255, 255, 255, 0);
    padding-left: 5px;
  }
  .p-label {
    font-size: 9pt;
    color: #1d1d1d;
    font-weight: 600;
  }
  .p-content-id-text {
    font-size: 13pt;
    font-weight: 600;
  }
  .p-content-field {
    font-size: 12pt;
  }
  .p-content-field-empty {
    font-size: 10pt;
    color: #96989A;
  }
  .flex-custom-field {
    margin-left: 10px;
    margin-right: 10px;
  }
</style>

<script>
  /* eslint-disable eqeqeq, camelcase, no-useless-escape */
  import PCustomFieldEditable from './PCustomFieldEditable'
  import PSelect from './PSelect'
  import PDate from './PDate'
  import PMoney from './PMoney'
  import PFile from './PFile'
  import access from '../../mixin/access'
  import plan from '../../mixin/plan'
  import rules from '../../mixin/rules'
  export default {
    mixins: [access, plan, rules],
    components: {PCustomFieldEditable, PSelect, PDate, PMoney, PFile},
    props: {
      // origin_field_name task_id ou tasktemplate_id
      origin_field_name: {
        type: String,
        default: 'tasktemplate_id'
      },
      task_id: {
        type: Number,
        default: 0
      },
      tasktemplate_id: {
        type: Number,
        default: 0
      },
      // view usado para saber se está na inclusão ou edição da tarefa ou tarefa modelo, para fazer os devidos tratamentos
      originView: {
        type: Number,
        default: 0
      },
      // variavel que armazena se o usuário está em uma tarefa compartilhada ou não
      task_shared: {
        type: Boolean,
        default: false
      },
      // variavel que armazena se o usuário possui acesso ou não naquela tarefa
      crud_access: {
        type: Boolean,
        default: true
      }
    },
    sockets: {
      // socket utilizado para alterar os dados do taskFile, quando utilizado pelo mixin do socket todos os dados alterados são referentes ao Task.vue
      editSocketCustomField (item) {
        // tira o value para não substituir eles
        delete item['value']
        delete item['value_item']
        this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/edit_value`, item)
        this.$store.commit('snackbar/change_values', {
          text: `Houve alterações nesta tarefa, poderá haver conflitos. Verifique as mudanças.`, color: 'warning', dialog: true, timeout: 10000
        })
      },
      addSocketCustomField (item) {
        // Caso seja tarefa não vem o value, pois ele é da tarefa modelo
        if (this.origin_field_name === 'task_id') {
          item['value'] = null
          item['value_item'] = null
          this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/add_value`, item)
        } else {
          this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/add_value`, item)
        }
        this.$store.commit('snackbar/change_values', {
          text: `Houve alterações nesta tarefa, poderá haver conflitos. Verifique as mudanças.`, color: 'warning', dialog: true, timeout: 10000
        })
      },
      deleteSocketCustomField (customFieldId) {
        let customField = this.customFields.find((val) => { return val['id'] == customFieldId })
        console.log('customFieldsdeleteSocketCustomField', customFieldId, customField, this.customFields)
        // so remove o valor se for tarefa modelo, ou se estiver na tarefa normal e o value for null ou tiver files, pois o value do files é sempre null
        if (this.origin_field_name === 'tasktemplate_id' || (customField && !customField['value'])) {
          if (customField['type'] !== 'files' || customField['files'].length <= 0) {
            this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/delete_value`, customFieldId)
            this.$store.commit('snackbar/change_values', {
              text: `Houve alterações nesta tarefa, poderá haver conflitos. Verifique as mudanças.`, color: 'warning', dialog: true, timeout: 10000
            })
          }
        }
      },
      // Socket quando muda o valor de um campo personalizado
      updateSocketCustomField (item) {
        // edita o customField
        this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/edit_value`, item)
        this.$store.commit('snackbar/change_values', {
          text: `Houve alterações nesta tarefa, poderá haver conflitos. Verifique as mudanças.`, color: 'warning', dialog: true, timeout: 20000
        })
      },
      // evento para adicionar arquivo no campo personalizado
      addFileCustomField (file) {
        // edita o customField
        this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/add_file`, file)
        this.$store.commit('snackbar/change_values', {
          text: `Houve alterações nesta tarefa, poderá haver conflitos. Verifique as mudanças.`, color: 'warning', dialog: true, timeout: 20000
        })
      },
      // evento para adicionar arquivo no campo personalizado
      deleteFileCustomField (file) {
        // edita o customField
        this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/delete_file`, file)
        this.$store.commit('snackbar/change_values', {
          text: `Houve alterações nesta tarefa, poderá haver conflitos. Verifique as mudanças.`, color: 'warning', dialog: true, timeout: 20000
        })
      }
    },
    data: () => ({
      loadingCustomFields: false,
      dialogConfirmConnection: false,
      // fieldEditing identifica e gerencia qual o campo que está em edição
      entity: 'custom_fields',
      // nome da tabela de origem tasks ou tasktemplates
      originTable: 'tasktemplates',
      // fieldEditing: {'cf_3': false, 'cf_4': false, 'cf_5': false, 'cf_6': false, 'cf_7': false, 'cf_8': false, 'cf_9': false},
      fieldEditing: {},
      defaultFieldEditing: {},
      editedItem: {},
      beforeEditedItem: {},
      // beforeTasktemplateId serve para saber a ultima sala que o usuário estava e tirar ele dela
      beforeTasktemplateId: 0,
      // beforeConnectionId serve para saber a ultima sala que o usuário estava e tirar ele dela
      beforeConnectionId: 0,
      moneyOptions: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */
      }
    }),
    created () {
      // zera os valores dos campos personalizados quando cria, pois na inclusão estava ficando vestigios de quando editava
      this.$emit('qtdCustomFields', 0)
      this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/change_values`, [])
      this.originTable = (this.origin_field_name === 'task_id' ? 'tasks' : 'tasktemplates')
    },
    methods: {
      openCustomFieldEditable (openDialog = true) {
        if (openDialog) {
          this.$refs.customFieldEditable.openDialog()
          this.dialogConfirmConnection = false
        } else {
          this.dialogConfirmConnection = true
        }
      },
      //  clickFieldEditing(field) criado para quando a tarefa ou a tarefa modelo for inclusão os campos já vem abertos, portanto o click faz a função de quando o campo vem aberto
      clickFieldEditing (field) {
        if (this.originView === 2) this.clickFieldEdit(field, false)
      },
      // click usado para saber se deve clicar ou não, pois quando ver da inclusão de uma tarefa ou tarefa modelo, os campos já vem abertos, portanto não precisa clicar
      // Select usado quando é um campo de valor, pois ele não funciona so com o click para já focar no campo
      clickFieldEdit (field, click = true, select = false) {
        if (!this.checkPermission(this.originTable, (this.originView === 2 ? 'create' : 'edit')) || this.task_shared || !this.crud_access) {
          this.$store.commit('snackbar/change_values', {text: 'Você não possui permissões para editar!', color: 'warning', dialog: true})
          return false
        }
        let fieldId = 'cf_' + field['id']
        // this.$set(this.defaultFieldEditing, `cf_${field['id']}`, false)
        // fecha todos os campos que estão abertos tanto nos campos principais como nos personalizados
        this.$emit('closeFieldEditing')
        // Uma das utilidades do beforEditItem é verifica se o valor foi alterado para salvar
        this.beforeEditedItem = JSON.parse(JSON.stringify(field))
        // Habilita a edição do filtro
        this.fieldEditing[fieldId] = true
        if (click) {
          // o i será o numero de tentativas para não tentar infinitamente
          let i = 0
          // coloca um interval para tentar quando não encontra o componente de primeira, isso pode acontece quando o componente vem do socket
          let intervalField = setInterval(() => {
            i++
            let fieldTag = document.getElementById(fieldId)
            if (fieldTag) {
              fieldTag.click()
              if (select) fieldTag.select()
              clearInterval(intervalField)
            }
            // caso não encontre o componente depois de 2 segundos então para de tentar
            if (i > 20) clearInterval(intervalField)
          }, 100)
        }
      },
      fieldEdit (values, field) {
        // não permite o usuário editar caso não tenha acesso
        if (!this.checkPermission(this.originTable, (this.originView === 2 ? 'create' : 'edit')) || this.task_shared) {
          this.$store.commit('snackbar/change_values', {text: 'Você não possui permissões para editar!', color: 'warning', dialog: true})
          return false
        }
        // Verifica se passou pro todas as validações
        console.log('cf_ ' + values['id'] + '_form', this.$refs['cf_ ' + values['id'] + '_form'][0])
        if (this.$refs['cf_ ' + values['id'] + '_form'][0] && !this.$refs['cf_ ' + values['id'] + '_form'][0].validate()) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        // Se estiver em modo de inclusão ou for campos dos clientes não precisa do loading
        if (this.originView != 2 && this.origin_field_name != 'connection_id') this.$store.commit('loader/change_dialog', true)
        this.editedItem = JSON.parse(JSON.stringify(values))
        setTimeout(() => {
          if ((this.$refs[field + '_form'] && !this.$refs[field + '_form'].validate())) {
            this.$store.commit('snackbar/change_values', {
              text: 'Por favor, corrija as validações antes de salvar!',
              color: 'warning',
              dialog: true
            })
            this.$store.commit('loader/change_dialog', false)
            this.editedItem = JSON.parse(JSON.stringify(this.beforeEditedItem))
            return false
          }
          this.fieldEditing[field] = false
          // verifica se foi alterado algum valor, caso tenha sido alterado, salva.
          // tbm verifica quando o valor é null pois nesse caso foi clicaco no x e no x o beforeEditedItem ainda não recebeu valores sendo null tbm
          let saveValues = false
          for (var prop in values) {
            if (values[prop] != this.beforeEditedItem[prop] || values[prop] === null) {
              saveValues = true
            }
          }
          // if (saveValues) this.savePut(values, editedItem)
          if (saveValues) {
            // faz o editedItem receber os valores no caso de vir null
            Object.assign(this.editedItem, JSON.parse(JSON.stringify(values)))
            this.save()
          } else {
            this.$store.commit('loader/change_dialog', false)
          }
        }, 100)
      },
      save () {
        // if (!this.$refs.form.validate()) {
        //   this.$store.commit('snackbar/change_values', {text: 'Por favor, corrija as validações antes de salvar!', color: 'warning', dialog: true})
        //   return false
        // }
        // Insere a origem para saber onde usar na edição
        this.editedItem['origin_field_name'] = this.origin_field_name
        this.editedItem['task_id'] = this.task_id
        // caso seja inclusão da Tarefa ou tarefa modelo ou seja campos de clientes, não salva no banco
        if (this.originView === 2 || this.origin_field_name == 'connection_id') {
          this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/edit_value`, this.editedItem)
          this.closeFieldEditing()
        } else {
          this.$http.put('api/update_value/' + this.editedItem.id,
            this.editedItem).then(
            (res) => {
              this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/edit_value`, res.body)
              // ---- Inicio Socket----
              let room = this.origin_field_name === 'task_id' ? `tasks${this.task_id}_manage` : `tasktemplates${this.$auth.user().company_id}_${this.tasktemplate_id}`
              this.$socket.emit('generalEvent', {
                data: res.body,
                responseEvent: 'updateSocketCustomField',
                room: room
              })
              // ---- Fim Socket----
              this.closeFieldEditing()
              this.$store.commit('snackbar/change_values', {text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' editado com sucesso!', color: 'success', dialog: true})
            },
            err => {
              alert('Erro! Falha ao enviar a requisição.')
              console.log(err)
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', {text: 'Não foi possível editar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
            }
          )
        }
      },
      addFiles (files, field) {
        let values = {
          'custom_field_id': field['id'],
          'save_bd': this.originView !== 2,
          'task_id': this.task_id,
          'user_id': this.$auth.check() ? this.$auth.user().id : null,
          'company_id': field['company_id'],
          'connection_company_id': 25,
          'files': files
        }
        // Adiciona o id do campo personalizado para saber diferenciar no momento de salvar
        this.$store.dispatch(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/add_files`, values).then((files) => {
          // se for diferente de criação significa que esta no gerenciamento da tarefa, logo deve mandar os sockets por arquivo
          if (this.originView !== 2 && Array.isArray(files)) {
            files.forEach(file => {
              this.$socket.emit('generalDetailsEvent', {
                data: file,
                notBroadcast: true,
                details: 'files',
                responseEvent: 'addSocketDetails',
                room: `tasks${file['task_id']}_manage`
              })
              // Emitindo evento para adicionar arquivo no campo personalizado
              this.$socket.emit('generalEvent', {
                data: file,
                responseEvent: 'addFileCustomField',
                room: `tasks${file['task_id']}_manage`
              })
              // linha utilizada para informar a Tela de Arquivos que este elemento veio da tela de Tarefas
              file['source'] = 2
              // Emitindo evento para adicionar arquivo à tela de arquivos
              this.$socket.emit('generalEvent', {
                data: file,
                responseEvent: 'addSocketItem',
                room: `files${file['company_id']}`
              })
            })
          }
        }, err => {
          console.log(err)
          // caso tenha sido barrado porque o plano excedeu o limite, mostra a msg de erro
          if (err.body.message.includes('limit|')) {
            // busca a memoria do plano do usuário
            let sizePlan = this.getterAccesses.find((res) => {
              return (res.id_text === 'files' && res.hasOwnProperty('size'))
            })
            // caso não tenha a variavel de tamanho, insere 0
            sizePlan = !sizePlan ? 0 : sizePlan['size']
            // transforma bit em mb
            let sumSizeFiles = (parseInt(sizePlan) - parseInt(err.body.message.split('|')[1])) / 1000000
            this.$store.commit('dialogPlan/change_values', {
              title: 'Memória excedida',
              text: `Esse arquivo ultrapassa o limite do seu plano, você tem apenas <strong>${Math.round(sumSizeFiles)}mb disponível</strong>. Aproveite e faça o upgrade agora mesmo!`,
              showDialog: true
            })
          } else {
            this.$store.commit('snackbar/change_values', { text: `Ocorreu um erro ao salvar os arquivos reporte o erro!`, color: 'error', dialog: true })
            this.$store.commit('loader/change_dialog', false)
          }
        })
      },
      changeCustomFields (items) {
        this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/change_values`, items)
        this.setFieldEditing()
      },
      // Busca os campos personalizados
      // inserido o originView, pois quando ele vem da inclusão de tarefa (ao alterar uma tarefa modelo na inclusão de tarefa), o originView muda para 0
      // E quando vem dos clientes deve passar como edição para buscar os valores
      getCustomFields (origin_field_name = this.origin_field_name, task_id = this.task_id, tasktemplate_id = this.tasktemplate_id, originView = this.originView, connection_id = this.connection_id) {
        // Tira o usuário da ultima sala que estava
        this.$socket.emit('leaveRoom', {room: `${this.origin_field_name == 'connection_id' ? 'connections_cf_' + this.beforeConnectionId : 'tasktemplates_cf_' + this.beforeTasktemplateId}`})
        // Adicionar o usuário na sala dos campos personalizados de acordo com o id da tarefa modelo pois por enquanto tanto na tarefa e na tarefa modelo os campos vem da tarefa modelo
        this.$socket.emit('joinRoom', {room: `${this.origin_field_name == 'connection_id' ? 'connections_cf_' + this.connection_id : 'tasktemplates_cf_' + this.tasktemplate_id}`})
        this.beforeTasktemplateId = this.tasktemplate_id
        this.beforeConnectionId = this.connection_id

        this.loadingCustomFields = true
        // quando é inclusão na tela de tarefa modelo os campos personalizados devem vir vazios, busca no banco apenas se a tarefa ou tarefa modelo for gerenciamento ou edição ou quando for inclusão de uma tarefa que tem que buscar os valores da tarefa modelo
        if (originView === 2) {
          this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/change_values`, [])
          this.loadingCustomFields = false
          this.$emit('qtdCustomFields', 0)
        } else {
          this.$http.get(`api/custom_fields${this.task_shared ? '_shared' : ''}?origin_field_name=${origin_field_name}&task_id=${task_id}&tasktemplate_id=${tasktemplate_id}&connection_id=${connection_id}`).then((res) => {
            this.$emit('qtdCustomFields', res.body.length)
            this.$store.commit(`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}/change_values`, res.body)
            this.setFieldEditing()
            this.loadingCustomFields = false
          }, err => {
            console.log(err)
            this.loadingCustomFields = false
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível incluir o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
          })
        }
      },
      // preenche o fieldediting pois se deixar ele sem preencher demora ao clicar no campo pra editar
      setFieldEditing () {
        this.fieldEditing = {}
        this.customFields.forEach(field => {
          this.$set(this.fieldEditing, `cf_${field['id']}`, false)
        })
        this.defaultFieldEditing = JSON.parse(JSON.stringify(this.fieldEditing))
      },
      // fecha todos os campos
      closeFieldEditing () {
        this.$store.commit('loader/change_dialog', false)
        Object.assign(this.fieldEditing, this.defaultFieldEditing)
      },
      getMaskField (type) {
        switch (type) {
          case 'phone':
            return '(##) #####-####'
          default:
            return null
        }
      },
      getRuleField (type, name) {
        switch (type) {
          case 'email':
            return this.emailRule(name, false, false)
          default:
            return []
        }
      },
      applyMaskField (value, mask) {
        if (mask) {
          let i = 0
          let v = value.toString()
          v = v.replace(/\D/g, '')
          return mask.replace(/#/g, () => v[i++] || '')
        } else {
          return value
        }
      }
    },
    computed: {
      customFields () {
        return this.$store.state[`${this.origin_field_name == 'connection_id' ? 'customFieldConnection' : 'customField'}`].values
      }
    },
    destroyed () {
      this.$socket.emit('leaveRoom', {room: `tasktemplates_cf_${this.tasktemplate_id}`})
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/shared/PCustomField.vue